import { Box, Layout } from '@zillow/constellation-10';
import { PaymentCardSkeleton } from './PaymentCardSkeleton';
import { TransactionsTableSkeleton } from './TransactionsTableSkeleton';

export const RentSkeleton = () => {
  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap: 'loose',
      }}
      data-testid="RentSkeleton"
    >
      <Box css={{ display: { base: 'block', lg: 'none' } }}>
        <PaymentCardSkeleton isMobile={true} />
      </Box>
      <Box css={{ display: { base: 'none', lg: 'block' } }}>
        <Layout.Root template="fluid12">
          <Layout.Content css={{ gridColumnEnd: { base: 'span 12', md: 'span 6', lg: 'span 4' }, padding: '0' }}>
            <PaymentCardSkeleton isMobile={false} />
          </Layout.Content>
        </Layout.Root>
      </Box>
      <Box css={{ display: { base: 'block', lg: 'none' } }}>
        <TransactionsTableSkeleton isDesktop={false} />
      </Box>
      <Box css={{ display: { base: 'none', lg: 'block' } }}>
        <TransactionsTableSkeleton isDesktop={true} />
      </Box>
    </Box>
  );
};
